import { ShoppingBag, Sparkles } from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useCart } from "@/context/CartContext";

const scrollTo = (id) => {
    if (window.__lenis) {
        window.__lenis.scrollTo(id, { offset: -70 });
    } else {
        document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
    }
};

export const Header = () => {
    const { count, setCartOpen } = useCart();
    const location = useLocation();
    const navigate = useNavigate();
    const go = (id) => {
        if (location.pathname !== "/") {
            navigate(`/${id}`);
            return;
        }
        scrollTo(id);
    };
    return (
        <header className="fixed inset-x-0 top-0 z-50 border-b border-vault-border bg-[#fdfbf7]/80 backdrop-blur-xl">
            <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
                <Link
                    data-testid="nav-logo"
                    to="/"
                    className="font-display text-lg uppercase tracking-wide text-stone-900 sm:text-xl"
                >
                    Vault<span className="text-vault-red">Deportivos</span>
                </Link>
                <nav className="hidden items-center gap-8 font-mono text-xs tracking-[0.25em] text-stone-600 md:flex">
                    <button data-testid="nav-drop-link" onClick={() => go("#drop")} className="transition-colors hover:text-stone-900">
                        DROPS
                    </button>
                    <button data-testid="nav-process-link" onClick={() => go("#process")} className="transition-colors hover:text-stone-900">
                        PROCESS
                    </button>
                    <button data-testid="nav-custom-link" onClick={() => go("#custom")} className="transition-colors hover:text-stone-900">
                        CUSTOM
                    </button>
                </nav>
                <div className="flex items-center gap-3">
                    <Link
                        data-testid="nav-vault-ai-link"
                        to="/vault-ai"
                        className="flex items-center gap-2 border border-vault-red px-3 py-2 font-mono text-[10px] tracking-[0.2em] text-vault-red transition-colors hover:bg-vault-red hover:text-stone-900 sm:px-4 sm:text-xs"
                    >
                        <Sparkles size={13} />
                        VAULT AI
                    </Link>
                    <button
                        data-testid="cart-trigger"
                        aria-label="Open cart"
                        onClick={() => setCartOpen(true)}
                        className="relative flex items-center gap-2 border border-vault-border px-3 py-2 font-mono text-[10px] tracking-[0.2em] text-stone-900 transition-colors hover:border-vault-red hover:text-vault-red sm:px-4 sm:text-xs"
                    >
                        <ShoppingBag size={15} />
                        <span className="hidden sm:inline">CART</span>
                        <span
                            data-testid="cart-count"
                            className="absolute -right-2 -top-2 flex h-5 min-w-5 items-center justify-center bg-vault-red px-1 font-mono text-[10px] text-stone-900"
                        >
                            {count}
                        </span>
                    </button>
                </div>
            </div>
        </header>
    );
};
